import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebaseConfig';

export function normalizePhoneForDoc(phone) {
  const raw = String(phone || '').trim();
  if (!raw) return '';

  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';

  if (raw.startsWith('+')) return `+${digits}`;
  if (digits.length === 10) return `+91${digits}`;
  if (digits.startsWith('91') && digits.length === 12) return `+${digits}`;
  return `+${digits}`;
}

export function getSubscriptionDocRef(phone) {
  return doc(db, 'subscriptions', normalizePhoneForDoc(phone));
}

// Single-source strategy: always use canonical +91... subscription doc id.
export async function resolveSubscriptionDoc(phone) {
  const canonicalId = normalizePhoneForDoc(phone);
  const canonicalRef = doc(db, 'subscriptions', canonicalId);
  const canonicalSnap = await getDoc(canonicalRef);
  return { ref: canonicalRef, snap: canonicalSnap, id: canonicalId };
}
